<div *ngIf="loading" class="loading">
    <loader type="page"> </loader>
</div>

<ng-container *ngIf="filesSection && !loading">
    <div class="header">
        <div class="header__title" *ngIf="!isMobile">Документы</div>
    </div>
    <div *ngIf="loading" class="loading">
        <loader type="page"></loader>
    </div>

    <ng-container *ngIf="filesSection && !loading">
        <div class="wrapper">
            <!-- Список документов -->
            <div class="left">
                <div
                    *ngFor="let document of documentsList; let i = index"
                    [ngClass]="{
                        document_card_active: i === selectedIndex
                    }"
                    (click)="
                        load_document
                            ? null
                            : getDocument(
                                  $event,
                                  document.id,
                                  document.file_name,
                                  i
                              )
                    "
                >
                    <div class="year" *ngIf="isBlockYear(i)">
                        {{ getYear(i) }}
                    </div>
                    <div class="document_card">
                        <div class="document_format">
                            {{ getFileFirmat(document.file_name) }}
                        </div>
                        <div class="document__middle">
                            <div class="document_title">
                                {{ document.file_name }}
                            </div>
                            <div class="document_date">
                                {{ document.dat_str }}
                            </div>
                        </div>
                        <button
                            class="download-file__button"
                            (click)="
                                downloadFile(
                                    $event,
                                    document.id,
                                    document.file_name,
                                    i
                                )
                            "
                        >
                            <mat-icon
                                svgIcon="download-file"
                                class="download-file"
                            ></mat-icon>
                        </button>
                    </div>
                </div>
            </div>
            <div *ngIf="documentsList.length < 1" class="documents_not_found">
                <h3>Документы не найдены</h3>
            </div>

            <!-- Контент документа -->

            <div
                class="right"
                *ngIf="
                    (documentsList.length > 0 &&
                        (selectedIndex !== null || !isMobile)) ||
                    (isMobile && selectedIndex !== null)
                "
                [class.right--mobile]="isMobile"
            >
                <!-- *ngIf="
                        !activeImgInBase64 &&
                        !downloadLink &&
                        !load_document &&
                        !isMobile &&
                        selectedIndex === null
                    " -->
                <div class="not-selected-document" *ngIf="!isMobile">
                    <p>
                        {{ selectedItem?.file_name || "Выберите документ" }}
                    </p>
                </div>
                <!-- <div class="right__content"> -->
                <div class="mobile__header" *ngIf="isMobile">
                    <button
                        class="right__close-btn"
                        *ngIf="isMobile"
                        (click)="handleClose()"
                    >
                        <img
                            src="./assets/img/svg/arrow_back.svg"
                            alt="arrow_back"
                        />
                    </button>
                    <div class="right__header" *ngIf="isMobile">
                        <span> Информация по документу</span>
                        <span>
                            {{ selectedItem?.file_name || "Выберите документ" }}
                        </span>
                    </div>
                    <div
                        class="download-file__button"
                        disabled="(downloadLink)"
                    >
                        <a
                            [href]="downloadLink"
                            rel="noopener"
                            [download]="fileNameWithExt"
                        >
                            <mat-icon
                                svgIcon="download-file"
                                class="download-file"
                            ></mat-icon
                        ></a>
                    </div>
                </div>
                <div class="right_document">
                    <div class="image-wrapper">
                        <img
                            [src]="activeImgInBase64"
                            class="right_document-img"
                        />
                    </div>
                    <!-- <img
                        [src]="activeImgInBase64"
                        *ngIf="activeImgInBase64"
                        class="right_document-img"
                    /> -->
                    <div
                        *ngIf="downloadLink && !activeImgInBase64"
                        class="underSVG"
                    >
                        <mat-icon
                            svgIcon="no-preview"
                            class="no-preview"
                        ></mat-icon>
                        <span class="underSVG__text">
                            Документ недоступен для предпросмотра</span
                        >
                    </div>
                    <!-- *ngIf="downloadLink && !activeImgInBase64" -->
                    <div
                        class="download_link"
                        *ngIf="selectedItem && !load_document"
                    >
                        <a
                            [href]="downloadLink"
                            rel="noopener"
                            [download]="fileNameWithExt"
                            >Скачать</a
                        >
                    </div>
                    <div *ngIf="load_document" class="loader">
                        <loader type="page"></loader>
                    </div>
                </div>
                <!-- </div> -->
            </div>
        </div>
    </ng-container>
</ng-container>
